import type { JSX } from "react";
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@mailflare/ui";

import { useAppShell } from "@/app/layout/app-shell";

import { MailboxesSection } from "./mailboxes-section";
import { SecuritySection } from "./security-section";
import { SessionsSection } from "./sessions-section";

export function SettingsPage(): JSX.Element {
  const { user } = useAppShell();

  return (
    <div className="mx-auto w-full max-w-3xl p-4 sm:p-6">
      <Card className="mb-6">
        <CardHeader>
          <CardTitle>
            <h1>Settings</h1>
          </CardTitle>
          <CardDescription>
            {user.displayName} · {user.email} · role {user.role}
          </CardDescription>
        </CardHeader>
      </Card>

      <Tabs defaultValue="security">
        <TabsList>
          <TabsTrigger value="security">Security</TabsTrigger>
          <TabsTrigger value="sessions">Sessions</TabsTrigger>
          <TabsTrigger value="mailboxes">Mailboxes</TabsTrigger>
        </TabsList>
        <TabsContent value="security" className="pt-4">
          <SecuritySection />
        </TabsContent>
        <TabsContent value="sessions" className="pt-4">
          <SessionsSection />
        </TabsContent>
        <TabsContent value="mailboxes" className="pt-4">
          <MailboxesSection />
        </TabsContent>
      </Tabs>
    </div>
  );
}
